module.exports = __webpack_public_path__ + "img/eagle_logo.63bfef51.png";